import decorateComponentWithProps from 'decorate-component-with-props'
import Link from '../custom-blocks/link'

function linkStrategy(
  contentBlock: Record<string, any>,
  callback: (...args: Array<any>) => any,
  contentState: Record<string, any>,
) {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity()
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'LINK'
    )
  }, callback)
}

export default (
  config: Record<string, any> = {},
): {
  decorators: Array<{
    component: any
    strategy: (contentBlock: any, callback: any, contentState: any) => void
  }>
} => {
  const { target = '_blank', rel = 'noreferrer noopener' } = config
  return {
    decorators: [
      {
        strategy: linkStrategy,
        component: decorateComponentWithProps(Link, {
          target,
          rel,
        }),
      },
    ],
  }
}
